import { initDatabase } from '@scalar-org/mongobase-client'

import { config } from '@/config'
import { getAuthData } from '@/helpers/auth'

export const getDatabaseClient = async (): Promise<
  ReturnType<typeof initDatabase>
> => {
  const client = initDatabase(`${config.services.api}/rtdb`)

  const auth = await getAuthData()
  auth.addEventListener((state) => {
    Object.assign(auth, state)
    client.updateAccessToken(state.accessToken)
  })

  client.updateAccessToken(auth.accessToken)

  return client
}
